import React from 'react';

export const CrossSvg = props => 
    <svg x="0px" y="0px" viewBox="0 0 138 138">
        <path d="M69,0C30.9,0,0,30.9,0,69s30.9,69,69,69s69-30.9,69-69S107.1,0,69,0z M105.1,95.9l-9.2,9.2L69,78.2l-26.9,26.9
	l-9.2-9.2L59.8,69L32.9,42.1l9.2-9.2L69,59.8l26.9-26.9l9.2,9.2L78.2,69L105.1,95.9z"/>
    </svg>